import { defineMessages } from 'react-intl';

import { Locales } from '@ratehub/base-ui';

import RichTextBlock from '../components/RichTextBlock';
import getBlogCategoryPath from '../functions/getBlogCategoryPath';
import getHeroDetailsFromPost from '../functions/getHeroDetailsFromPost';


const FALLBACK_EXCERPT_CHARACTER_COUNT = 140;

function extractBlogPost(post, options) {
    return {
        title: replaceEncodedCharacters(post.title.rendered),
        message: getExcerpt(post),

        ...getHeroDetailsFromPost(post),
        imagePositionX: '50%',
        imagePositionY: '50%',

        href: options.locale === Locales.FRENCH
            ? `/blogue/${post.slug}/`
            : `/blog/${post.slug}/`, // Trailing slash is desired for /blog or /blogue
        hrefText: MESSAGES.READ_POST,
        isImageAndTitleALink: true,

        tags: post.category_details.map(category => ({
            title: category.name,
            href: getBlogCategoryPath(category, options.locale),
        })),
    };
}

function getExcerpt(post) {
    return post.excerpt.rendered.length
        ? stripHTMLTags(post.excerpt.rendered)
        : `${getRichText(post)} …`;
}

function getRichText(post) {
    const postBlocks = post.rh_blocks;
    const richTextBlock = postBlocks.find(block =>
        (block.blockName === RichTextBlock.blockKey) && block.innerHTML);

    let content = richTextBlock
        ? richTextBlock.innerHTML
        : '';

    // Strip HTML tags
    content = typeof content === 'string'
        ? stripHTMLTags(content)
        : '';

    if (content.charAt(FALLBACK_EXCERPT_CHARACTER_COUNT) !== ' ') {
        for (let i = FALLBACK_EXCERPT_CHARACTER_COUNT + 1; i < content.length; i++) {
            if (content.charAt(i) === ' ') {
                content = content.slice(0, i);
                break;
            }
        }

        return content;
    } else {
        return content.slice(0, FALLBACK_EXCERPT_CHARACTER_COUNT);
    }
}

function stripHTMLTags(string) {
    string = string.replace(/<[^>]+>/gi, '');
    return replaceEncodedCharacters(string);
}

function replaceEncodedCharacters(string) {
    return string.replace(/&nbsp;/g, ' ').replace(/&#8217;/g, '\'').trim();
}

const MESSAGES = defineMessages({
    READ_POST: {
        id: 'web-components.extractBlogPost.ReadPost',
        defaultMessage: 'Read article',
    },
});

export default extractBlogPost;
